import { UPDATE_LANGUAGE } from "../actionTypes";

const INITIAL_STATE = {};

const reducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case UPDATE_LANGUAGE:
      return { ...state, ...action.languages };
    default:
      return state;
  }
};

export default reducer;
